<template>
  <div class="packages-list-item">
    <v-row class="my-0" align="center" >
      <v-col sm="1">
        <div v-if="generalApp.ordersActionStarted && !noAction">
          <!-- <v-tooltip
            bottom
            v-if="!isSelected && pckg.parentID !== null"
          >
            <template v-slot:activator="{ on }">
              <v-checkbox
                hide-details
                indeterminate
                disabled
                readonly
                class="mt-0 pt-0"
                v-on="on"
                @click="function(){return undefined}"
              />
            </template>
            <span>Package is already in another pallet. Can not be selected!</span>
          </v-tooltip> -->
          <v-checkbox
            :value="isSelected"
            :input-value="isSelected"
            @change="selectPackageToAction()"
            color="kazan"
            hide-details
            class="mt-0 pt-0"
            :ripple="false"
          />
        </div>
      </v-col>
      <v-col sm="2">
        {{pckg.id}}
      </v-col>
      <v-col sm="3">
        <LabelsList :labels="pckg.items" :showed="2"/>
      </v-col>
      <v-col sm="2">
        {{pckg.dimensions | dimensionValue()}}
      </v-col>
      <v-col sm="2">
        {{pckg.weight | roundValue(1) }} kg
      </v-col>
      <v-col sm="2">
        {{pckg.status}}
      </v-col>

    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LabelsList from '@/components/general/LabelsList'

export default {
  name: 'PackagesListItem',
  components: {
    LabelsList
  },
  props: {
    pckg: Object,
    order: Object,
    noAction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['generalApp']),
    isSelected: {
      get () {
        let includes = false
        for (let i = 0; i < this.generalApp.selectedPackages.length; i++) {
          if (this.generalApp.selectedPackages[i].id === this.pckg.id) {
            includes = true
            break
          }
        }
        return includes
      },
      set () {}
    }
  },
  methods: {
    ...mapActions({
      selectPackage: 'selectPackage',
      unselectPackage: 'unselectPackage'
    }),
    selectPackageToAction () {
      let tmpPackage = {
        id: this.pckg.id,
        weight: this.pckg.weight,
        volume: (this.pckg.dimensions.width * this.pckg.dimensions.length * this.pckg.dimensions.height) / 1000000, // in cubic meters
        dims: this.pckg.dimensions,
        order: this.order
      }
      if (this.isSelected) {
        this.unselectPackage(tmpPackage)
      } else {
        this.selectPackage(tmpPackage)
      }
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>
  .packages-list-item {
    border-top: 1px lightgray solid;
  }
</style>
